/* eslint-disable import/prefer-default-export */
import getAxiosInstance from '../../config/api';

export const loadConfig = req => async dispatch => {
  const axiosInstance = await getAxiosInstance(req);
  const { data } = await axiosInstance.get('/public/shopConfig');

  return dispatch({
    type: 'APPLY_WHITE_LABEL_CONFIG',
    payload: { data },
  });
};
